angular.module('leanlaw').factory('viewInvoiceService', ['leanLawAuth', '$window', 'leanLawApi', 'alerts', '$state', 'tracking', 'userService', function (leanLawAuth, $window, leanLawApi, alerts, $state, tracking, userService) {
  function viewInvoice(invoice, viewInvoiceOnly) {
    if (invoice.processed) {
      const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
      $window.open(url);
      return;
    }

    // Track Draft Invoice Opened event
    if (invoice.state && (invoice.state.draft || invoice.state.review)) {
      userService.me().then(me => {
        const trackingData = {
          invoiceId: invoice.id,
          invoiceState: invoice.state.draft ? 'draft' : 'review',
          sourceContext: me.company.settings && me.company.settings.demoMode ? 'trainingFlow' : 'regularUsage'
        };
        tracking.event('Draft Invoice', 'Opened', trackingData);
      });
    }
    const currentState = $state.current.name;
    const editState = `${currentState}.edit`;
    $state.go(editState, {
      invoiceId: invoice.id,
      onlyViewInvoice: viewInvoiceOnly
    });
  }
  function sendEmail(invoice) {
    bootbox.confirm(`Email the invoice to the client?`, result => {
      if (result) {
        leanLawApi.processInvoice({
          id: invoice.id,
          body: {
            send: true
          }
        }).then(() => {
          alerts.success('The invoice was successfully emailed to the client');
        }).catch(err => {
          alerts.error(err);
        });
      }
    });
  }
  return {
    viewInvoice,
    sendEmail
  };
}]);